export { type TwoColumnRichTextBlockProps, default as TwoColumnRichTextBlock } from './TwoColumnRichTextBlock';
